/**
 * Hook zum Laden lokalisierter Daten aus /src/i18n/data/.
 *
 * Verwendung:
 *   const { awards, trustNumbers } = useLocalizedData('awards');
 *
 * Fallback-Kette: aktuelle Sprache → 'de'.
 */
import { useTranslation } from 'react-i18next';

// --- Statische Imports (CRA-kompatibel) ----------------------------------
import awards_de from './data/awards.de.json';
import awards_en from './data/awards.en.json';
import awards_ar from './data/awards.ar.json';
import awards_tr from './data/awards.tr.json';
import awards_fr from './data/awards.fr.json';
import awards_it from './data/awards.it.json';

import team_de from './data/team.de.json';
import team_en from './data/team.en.json';
import team_ar from './data/team.ar.json';
import team_tr from './data/team.tr.json';
import team_fr from './data/team.fr.json';
import team_it from './data/team.it.json';

import testimonials_de from './data/testimonials.de.json';
import testimonials_en from './data/testimonials.en.json';
import testimonials_ar from './data/testimonials.ar.json';
import testimonials_tr from './data/testimonials.tr.json';
import testimonials_fr from './data/testimonials.fr.json';
import testimonials_it from './data/testimonials.it.json';

import selbsttest_de from './data/selbsttest.de.json';
import selbsttest_en from './data/selbsttest.en.json';
import selbsttest_ar from './data/selbsttest.ar.json';
import selbsttest_tr from './data/selbsttest.tr.json';
import selbsttest_fr from './data/selbsttest.fr.json';
import selbsttest_it from './data/selbsttest.it.json';

import rechtsgebiete_de from './data/rechtsgebiete.de.json';
import rechtsgebiete_en from './data/rechtsgebiete.en.json';
import rechtsgebiete_ar from './data/rechtsgebiete.ar.json';
import rechtsgebiete_tr from './data/rechtsgebiete.tr.json';
import rechtsgebiete_fr from './data/rechtsgebiete.fr.json';
import rechtsgebiete_it from './data/rechtsgebiete.it.json';

const DATA = {
  awards: { de: awards_de, en: awards_en, ar: awards_ar, tr: awards_tr, fr: awards_fr, it: awards_it },
  team: { de: team_de, en: team_en, ar: team_ar, tr: team_tr, fr: team_fr, it: team_it },
  testimonials: { de: testimonials_de, en: testimonials_en, ar: testimonials_ar, tr: testimonials_tr, fr: testimonials_fr, it: testimonials_it },
  selbsttest: { de: selbsttest_de, en: selbsttest_en, ar: selbsttest_ar, tr: selbsttest_tr, fr: selbsttest_fr, it: selbsttest_it },
  rechtsgebiete: { de: rechtsgebiete_de, en: rechtsgebiete_en, ar: rechtsgebiete_ar, tr: rechtsgebiete_tr, fr: rechtsgebiete_fr, it: rechtsgebiete_it },
};

/**
 * Liefert das geparste JSON-Objekt für den gewünschten Datensatz in der
 * aktuellen Sprache. Fällt auf Deutsch zurück, falls das Sprach-Bundle fehlt.
 */
export const useLocalizedData = (key) => {
  const { i18n } = useTranslation();
  const lang = (i18n.language || 'de').split('-')[0];
  const set = DATA[key];
  if (!set) return null;
  return set[lang] || set.de;
};
